import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { LoginRequest, UserResponse, RegisterRequest, LoginRegisterResponse} from './interface';
import { STRINGS } from '../../utils/strings';
import { secureStorageUtils } from '../../utils/secureStorageUtils';
import { logout } from '../../utils/authUtils';
// import { GetMessageResponseId } from '../messageView/interface';
// import { GetMessageResponseId } from '../home/interface';
// import useSecureStorage from '../../hooks/useSecureStorage';

export const authApi = createApi({
  
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: STRINGS.API_URL,
    prepareHeaders: (headers) => {
      const token = secureStorageUtils.getItem("access-token");
      // const token = localStorage.getItem("access-token");
    
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    
      headers.set("accept", "application/json");
      headers.set("Content-Type", "application/json");
      headers.set("X-CSRF-TOKEN", "");
    
      return headers;
    },
    validateStatus: (response) => {
      // Handle 401 responses globally
      if (response.status === 401) {
        console.log("401 Unauthorized - logging out user");
        logout(false); // Don't show toast for API-level 401s
      }
      return response.status < 500; // Don't treat 4xx errors as network errors
    },
  }),
  
  endpoints: (builder) => ({
    login: builder.mutation<LoginRegisterResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/userlogin',
        method: 'POST',
        body: credentials,
      }),
    }),
    register: builder.mutation<LoginRegisterResponse, RegisterRequest>({
      query: (userData) => ({
        url: '/usercreate',
        method: 'POST',
        body: userData,
      }),
    }),
    getUser: builder.query<UserResponse['data'], void>({
      query: () => '/user',
    }),
  //  getMessage: builder.query<GetMessageResponseId, string>({
  //        query: (id) => `/messages/${id}`,
  //      }),
  }),
  
});

export const { useLoginMutation, useGetUserQuery, useLazyGetUserQuery , useRegisterMutation } = authApi;
